/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useCallback } from 'react';
import Cropper, { Area } from 'react-easy-crop';
import Button from './Button';
import { cropImage } from '../util/cropImage';
import styles from '../sass/components/ImagePreview.module.scss';

interface Props {
  imageURL: string;
  onConfirm: (croppedImage: Blob) => void;
  onRetake: () => void;
}

const ImagePreviewWithOverlay: React.FC<Props> = (
  { imageURL, onConfirm, onRetake },
) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area>();
  const [, setPreviewUrl] = useState<string | null>(null);
  const [, setCroppedBlob] = useState<Blob>();

  const onCropComplete = useCallback(
    (_croppedArea, areaPixels: Area) => {
      setCroppedAreaPixels(areaPixels);
    },
    [],
  );

  const handleConfirm = async () => {
    if (!croppedAreaPixels) return;

    setCroppedBlob(await cropImage(imageURL, croppedAreaPixels, rotation));

    const blob = await cropImage(imageURL, croppedAreaPixels, rotation);
    const url = URL.createObjectURL(blob);
    setPreviewUrl(url);
    setCroppedBlob(blob);
    onConfirm(blob);
  };

  return (
    <div className={styles.previewContainer}>
      <div className={styles.cropperContainer}>
        <Cropper
          image={imageURL}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={1 / 4}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onRotationChange={setRotation}
          onCropComplete={onCropComplete}
        />
        <div className={styles.overlayGuide} />
      </div>

      <div className={styles.controls}>
        <label htmlFor="zoomRange">
          Zoom
          <input
            id="zoomRange"
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
          />
        </label>

        <label htmlFor="rotationRange">
          Rotation
          <input
            id="rotationRange"
            type="range"
            min={0}
            max={360}
            step={1}
            value={rotation}
            onChange={(e) => setRotation(Number(e.target.value))}
          />
        </label>
      </div>

      <div className={styles.previewButtons}>
        <Button variant="secondary" onClick={onRetake}>Retake</Button>
        <Button variant="primary" onClick={handleConfirm}>Confirm</Button>
      </div>
    </div>

  );
};

export default ImagePreviewWithOverlay;
